import {
  createStickyNote,
  CreateStickyNoteMutation,
  CreateStickyNoteMutationVariables,
  deleteStickyNote,
  DeleteStickyNoteMutation,
  DeleteStickyNoteMutationVariables,
  graphqlCall,
  updateStickyNote,
  UpdateStickyNoteMutation,
  UpdateStickyNoteMutationVariables,
} from '@akin-home/amplify';

export const updateStickyNoteMutation = (
  params: UpdateStickyNoteMutationVariables
) => graphqlCall<UpdateStickyNoteMutation>(updateStickyNote, params);

export const createStickyNoteMutation = (
  params: CreateStickyNoteMutationVariables
) => graphqlCall<CreateStickyNoteMutation>(createStickyNote, params);

export const deleteStickyNoteMutation = (
  params: DeleteStickyNoteMutationVariables
) => graphqlCall<DeleteStickyNoteMutation>(deleteStickyNote, params);
